<template>
  <transition name="slide-down">
    <div v-if="message" class="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 w-11/12 max-w-2xl">
      <div 
        class="px-4 sm:px-6 py-4 rounded-xl shadow-lg flex items-center backdrop-blur-sm"
        :class="alertClasses"
      >
        <div 
          class="w-10 h-10 rounded-lg flex items-center justify-center mr-3 shadow-md"
          :class="iconBgClass"
        >
          <svg v-if="type === 'error'" class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg v-else-if="type === 'success'" class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <span class="flex-1 font-medium">{{ message }}</span>
        <button 
          @click="$emit('close')" 
          class="ml-4 transition-colors p-1 rounded-full"
          :class="closeButtonClass"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GlobalError',
  props: {
    message: { type: String, default: '' },
    type: { 
      type: String, 
      default: 'error',
      validator: (v) => ['error', 'success', 'warning'].includes(v)
    }
  },
  emits: ['close'],
  computed: {
    alertClasses() {
      const classes = {
        error: 'bg-gradient-to-r from-red-50 to-red-100 border border-red-200 text-red-800',
        success: 'bg-gradient-to-r from-green-50 to-green-100 border border-green-200 text-green-800',
        warning: 'bg-gradient-to-r from-yellow-50 to-yellow-100 border border-yellow-200 text-yellow-800'
      };
      return classes[this.type];
    },
    iconBgClass() {
      const classes = {
        error: 'bg-gradient-to-br from-red-500 to-red-600',
        success: 'bg-gradient-to-br from-green-500 to-green-600',
        warning: 'bg-gradient-to-br from-yellow-500 to-yellow-600'
      };
      return classes[this.type];
    },
    closeButtonClass() {
      const classes = {
        error: 'text-red-600 hover:text-red-700 hover:bg-red-50',
        success: 'text-green-600 hover:text-green-700 hover:bg-green-50',
        warning: 'text-yellow-600 hover:text-yellow-700 hover:bg-yellow-50'
      };
      return classes[this.type];
    }
  }
}
</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease-out;
}

.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translate(-50%, -100%);
}
</style>
